import React, { useCallback } from 'react';

import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import EditIcon from '@mui/icons-material/Edit';

import Typography from '@ts-core/components/Typography';
import { formatDateTime } from '@ts-core/core/utils/dateFormatters';
import { TabData } from '@ts-core/core/hooks/ui';

import { ProfessorActivity } from '../../types';

interface ActivityPageHeaderProps {
  activity?: ProfessorActivity;
  loading?: boolean;

  tabs: TabData[];
  activeTab?: TabData;
  onGoToTab: (tabSlug: string) => void;

  onEditActivity?: (activity: ProfessorActivity) => void;
}

const ActivityPageHeader = (props: ActivityPageHeaderProps) => {
  const { activity, loading = false, onEditActivity, tabs, activeTab, onGoToTab } = props;

  const handleEditActivity = useCallback(() => {
    if (activity && onEditActivity) {
      onEditActivity(activity);
    }
  }, [activity, onEditActivity]);

  const handleChangeTab = useCallback(
    (event: any, newValue: string) => {
      onGoToTab(newValue);
    },
    [onGoToTab]
  );

  return (
    <Box>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" marginBottom={2}>
        <ButtonBase
          onClick={onEditActivity && handleEditActivity}
          disabled={!onEditActivity || loading}
          sx={{
            '&:hover': {
              opacity: 0.6,
            },
            transition: 'opacity 0.2s ease-in-out',
          }}
        >
          <Typography variant="h4" display="inline" loading={loading} skeletonProps={{ width: 160 }}>
            {activity?.name}
          </Typography>
          {!loading && onEditActivity && <EditIcon sx={{ ml: 1, mb: 0.5 }} />}
        </ButtonBase>
        <Typography variant="subtitle1" loading={loading} skeletonWidth={60}>
          {formatDateTime(activity?.deadline)}
        </Typography>
      </Box>
      <Box borderBottom={1} borderTop={1}>
        {activeTab && (
          <Tabs value={activeTab?.slug} centered onChange={handleChangeTab}>
            {tabs.map((tab) => (
              <Tab key={tab.slug} value={tab.slug} label={tab.label} />
            ))}
          </Tabs>
        )}
      </Box>
    </Box>
  );
};

export default ActivityPageHeader;
